import { render, staticRenderFns } from "./myBorder.vue?vue&type=template&id=8415fa3c"
import script from "./myBorder.vue?vue&type=script&lang=js"
export * from "./myBorder.vue?vue&type=script&lang=js"
import style0 from "./myBorder.vue?vue&type=style&index=0&id=8415fa3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports